const axios = require('axios').default

const analyticsEndpoint = `${process.env.API_BASE_URL}analytics/viewerEvents`

function performAnalyticsTracking(uuid, visibleImageRectangle, actionName) {
  const body = {
    name: actionName,
    imageUuid: uuid,
    clientDate: new Date().toISOString()
  }

  if (
    visibleImageRectangle.x &&
    visibleImageRectangle.y &&
    visibleImageRectangle.width &&
    visibleImageRectangle.height
  ) {
    body.visibleImageRectangle = {
      x_topleftPixel: Math.round(Number(visibleImageRectangle.x)),
      y_topleftPixel: Math.round(Number(visibleImageRectangle.y)),
      widthPixel: Math.round(Number(visibleImageRectangle.width)),
      heightPixel: Math.round(Number(visibleImageRectangle.height))
    }
  }

  return axios.post(analyticsEndpoint, body).catch(function (error) {
    console.log(JSON.stringify(error))
  })
}

export default {
  open: (uuid, visibleImageRectangle) => {
    return performAnalyticsTracking(uuid, visibleImageRectangle, 'open')
  },
  view: (uuid, visibleImageRectangle) => {
    return performAnalyticsTracking(uuid, visibleImageRectangle, 'view')
  },
  close: uuid => {
    return performAnalyticsTracking(uuid, {}, 'close')
  }
}
